import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";
import { SwitchProps } from "../Switch";

export const hoverStyle = (theme: Theme, disable: SwitchProps["disabled"]) => {
	return css`
		padding: 3px;
		display: inline-flex;
		border-radius: 9px;
		transition: 0.4s;
		&:hover {
			background: ${disable ? "none" : theme.colors.secondary_80_12};
		}
	`;
};

export const wrapperStyle = (theme: Theme, checked: SwitchProps["checked"], disabled: SwitchProps["disabled"]) => {
	return css`
		position: relative;
		display: inline-block;
		width: 30px;
		height: 18px;
		border-radius: 15px;
		background: ${switchBgSelector(theme, checked, disabled)};
		transition: 0.4s;
	`;
};

const switchBgSelector = (theme: Theme, checked: SwitchProps["checked"], disabled: SwitchProps["disabled"]) => {
	switch (disabled) {
		case true:
			if (checked) {
				return css`
					${theme.colors.neutral_50_100}
				`;
			} else {
				return css`
					${theme.colors.neutral_80_32}
				`;
			}
		case false:
			if (checked) {
				return css`
					${theme.colors.neutral_80_100}
				`;
			} else {
				return css`
					${theme.colors.neutral_50_100}
				`;
			}
		default:
			return css`
				${theme.colors.neutral_50_100}
			`;
	}
};

export const inputStyle = css`
	margin: 0;
	opacity: 0;
	width: 100%;
	height: 100%;
	cursor: pointer;
`;

export const dotStyle = (theme: Theme, checked: SwitchProps["checked"]) => css`
	position: absolute;
	top: 50%;
	left: 0px;
	width: 14px;
	height: 14px;
	background: ${theme.colors.neutral_00_100};
	border-radius: 30px;
	box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
	transition: 250ms all;
	transform: ${checked ? "translate(100%, -50%)" : "translate(2px, -50%)"};
`;
